import { TColor } from '@portals/external-services-header/lib/_components/header/_types';
import { THeaderButton } from '../../_types';

type TParams = {
  isTransparent: boolean;
} & Omit<THeaderButton, 'text'>;

export const getActionButtons = ({
  isTransparent,
  color,
  colorHex,
  textHex,
}: TParams): TColor => {
  if (color) {
    return {
      color,
    };
  }

  if (!color && !isTransparent) {
    return {
      colorHex: {
        enabled: '#f7f7fa',
        hovered: '#f0f0f3',
        disabled: '#fff',
      },
      textHex: {
        enabled: '#000',
        hovered: '#000',
        disabled: '#bbb7c9',
      },
    };
  }

  if (colorHex && textHex) {
    return {
      colorHex,
      textHex,
    };
  }

  return {
    color: 'off-white',
  };
};
